import React from 'react';
import { Box, Typography, Container, Card, CardContent, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BLOG_POSTS = [
  { title: 'Best AI Course in Patna', slug: 'best-ai-course-in-patna', description: 'Discover the best AI course in Patna. AI for Everyone - Generative AI, no coding required. Transform your career in 3 months.', image: '/ai-for-everyone.jpg' },
  { title: 'Best Python Course in Patna', slug: 'best-python-course-in-patna', description: 'Discover the best Python course in Patna. Master Python from basics to advanced. Build real-world applications.', image: '/learn-with-us-2.jpg' },
  { title: 'Best Robotics Course in Patna', slug: 'best-robotics-course-in-patna', description: 'Discover the best robotics course in Patna. Learn Arduino, sensors, IoT. Build line followers and smart systems.', image: '/beyond/live-events.jpg' },
];

const BlogSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="blog"
      sx={{
        position: 'relative',
        zIndex: 1,
        py: { xs: 6, md: 8 },
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)',
        borderTop: '1px solid #E5E7EB',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0 }}
        >
          <Typography
            component="h2"
            sx={{
              textAlign: 'center',
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 700,
              color: '#1E293B',
              mb: 1,
            }}
          >
            Blog
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
              color: '#64748B',
              fontSize: '1rem',
              mb: 4,
            }}
          >
            Insights, tutorials, and updates from Reviving India
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
              gap: 3,
            }}
          >
            {BLOG_POSTS.map((post, index) => (
              <motion.div
                key={post.slug}
                initial={false}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0 }}
              >
                <Card
                  onClick={() => navigate(`/blog/${post.slug}`)}
                  sx={{
                    height: '100%',
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                    border: '1px solid #E5E7EB',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 12px 32px rgba(0,0,0,0.1)',
                      transform: 'translateY(-4px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      width: '100%',
                      height: 200,
                      overflow: 'hidden',
                      bgcolor: '#1e293b',
                    }}
                  >
                    <Box
                      component="img"
                      src={post.image}
                      alt={post.title}
                      loading="eager"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'top',
                        imageRendering: 'auto',
                        transform: 'translateZ(0)',
                        backfaceVisibility: 'hidden',
                      }}
                    />
                  </Box>
                  <CardContent sx={{ p: 2.5 }}>
                    <Typography
                      component="h3"
                      sx={{
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        color: '#1E293B',
                        mb: 1,
                        lineHeight: 1.35,
                      }}
                    >
                      {post.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '0.9rem',
                        color: '#64748B',
                        lineHeight: 1.55,
                        mb: 2,
                      }}
                    >
                      {post.description}
                    </Typography>
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.5,
                        color: '#2563EB',
                        fontWeight: 600,
                        fontSize: '0.875rem',
                      }}
                    >
                      Read more
                      <ArrowRight size={16} />
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Button
              variant="outlined"
              endIcon={<ArrowRight size={18} />}
              onClick={() => navigate('/blog')}
              sx={{
                borderColor: '#2563EB',
                color: '#2563EB',
                fontWeight: 600,
                borderRadius: '30px',
                px: 3,
                '&:hover': {
                  borderColor: '#1D4ED8',
                  bgcolor: '#EAF2FF',
                },
              }}
            >
              View all posts
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default BlogSection;
